import { SearchIcon } from "app/components/Icons";
import { TabButton } from "app/components/ReplyComment/components/MentionDropdown/components/MentionMenuHeader/components/TabButton";
import {
  memberMenuSectionLabels,
  TabType,
} from "app/components/ReplyComment/components/MentionDropdown/types";
import { selectProjectSettingDetails } from "app/redux/selector";
import React, { FC } from "react";
import { useSelector } from "react-redux";
import { MenuSectionItem } from "./components/MenuSectionItem";
import { selectTicketDetails } from "app/containers/Features/containers/Ticket/redux/selectors";

interface MentionMenuHeaderProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  handleMemberMenuClick?: (memberId?: string) => () => void;
  showMemberMenu?: boolean;
}

const MentionMenuHeader: FC<MentionMenuHeaderProps> = ({
  activeTab,
  onTabChange,
  searchQuery,
  onSearchChange,
  handleMemberMenuClick,
  showMemberMenu,
}) => {
  // Global State
  const projectSettingDetail = useSelector(selectProjectSettingDetails);
  const {assignedTo,createdBy} = useSelector(selectTicketDetails);

  // Variables
  const memberMenuItems = [
    {
      id: memberMenuSectionLabels["ticket-creator"],
      label: memberMenuSectionLabels["ticket-creator"],
      _id: createdBy,
    },
    {
      id: memberMenuSectionLabels["default-assignee"],
      label: memberMenuSectionLabels["default-assignee"],
      _id: assignedTo,
    },
    {
      id: memberMenuSectionLabels["project-lead"],
      label: memberMenuSectionLabels["project-lead"],
      _id: projectSettingDetail?.lead,
    },
  ];

  return (
    <div className="flex flex-col gap-0 bg-white border-b border-gray-100 rounded-[4px]">
      {/* Tabs Header */}
      <div className="flex items-center gap-6 px-4">
        <TabButton
          label="Members"
          isActive={activeTab === TabType.Members}
          onClick={() => {
            onTabChange(TabType.Members);
            onSearchChange("");
          }}
        />
        <TabButton
          label="Tickets"
          isActive={activeTab === TabType.Tickets}
          onClick={() => {
            onTabChange(TabType.Tickets);
            onSearchChange("");
          }}
        />
      </div>

      <div className="px-2.5 mt-2.5 py-1.5">
        <div className="p-1.5 flex items-center gap-1.5 bg-white border border-gray-100 rounded-[4px]">
          <SearchIcon color="#BDC0C3" size="22px" />
          <input
            type="text"
            placeholder={
              activeTab === TabType.Members
                ? "Search by member's name"
                : "Search by ticket's name"
            }
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="flex-1 text-sm font-normal text-black placeholder-gray-300 outline-none bg-transparent"
          />
        </div>
      </div>

      {showMemberMenu && activeTab === TabType.Members ? (
        <div className="flex flex-col border-t border-gray-100">
          {memberMenuItems.map((item) => (
            <MenuSectionItem
              key={item.id}
              label={item.label}
              onClick={
                handleMemberMenuClick
                  ? handleMemberMenuClick(item?._id)
                  : () => {}
              }
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default MentionMenuHeader;
